import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

const Home = lazy(() =>
  import(/* webpackChunkName: "page-home" */ './pages/Home'),
);
const Login = lazy(() =>
  import(/* webpackChunkName: "page-login" */ './pages/Login'),
);
const SignUp = lazy(() =>
  import(/* webpackChunkName: "page-signup" */ './pages/SignUp'),
);
const ForgotPassword = lazy(() =>
  import(
    /* webpackChunkName: "page-forgot-password" */ './pages/ForgotPassword'
  ),
);
const About = lazy(() =>
  import(/* webpackChunkName: "page-about" */ './pages/About'),
);
const Support = lazy(() =>
  import(/* webpackChunkName: "page-support" */ './pages/Support'),
);
const Pricing = lazy(() =>
  import(/* webpackChunkName: "page-pricing" */ './pages/Pricing'),
);
const PrivacyPolicy = lazy(() =>
  import(/* webpackChunkName: "page-privacy" */ './pages/PrivacyPolicy'),
);
const TermsService = lazy(() =>
  import(/* webpackChunkName: "page-terms" */ './pages/TermsService'),
);
const MyAppsPage = lazy(() =>
  import(/* webpackChunkName: "page-my-apps" */ './pages/MyAppsPage'),
);
const MyAppsDetail = lazy(() =>
  import(/* webpackChunkName: "page-my-apps-detail" */ './pages/MyAppsDetail'),
);
const MyAccount = lazy(() =>
  import(/* webpackChunkName: "page-my-account" */ './pages/MyAccount'),
);
const MySubscription = lazy(() =>
  import(
    /* webpackChunkName: "page-my-subscription" */ './pages/MySubscription'
  ),
);
const CheckoutUser = lazy(() =>
  import(/* webpackChunkName: "page-checkout-user" */ './pages/CheckoutUser'),
);
const CheckoutUserPayment = lazy(() =>
  import(
    /* webpackChunkName: "page-checkout-payment" */ './pages/CheckoutUserPayment'
  ),
);
const CheckoutSuccess = lazy(() =>
  import(
    /* webpackChunkName: "page-checkout-success" */ './pages/CheckoutSuccess'
  ),
);

const Routers = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={null}>
        <Switch>
          <Route path="/my-apps" component={MyAppsPage} />
          <Route path="/my-apps-detail/:appId" component={MyAppsDetail} />
          <Route path="/my-account" component={MyAccount} />
          <Route path="/checkout-user" component={CheckoutUser} />
          <Route
            path="/checkout-user-payment"
            component={CheckoutUserPayment}
          />
          <Route path="/checkout-success" component={CheckoutSuccess} />
          <Route path="/my-subscription" component={MySubscription} />
          <Route path="/sign-up" component={SignUp} />
          <Route path="/login" component={Login} />
          <Route path="/pricing" component={Pricing} />
          <Route path="/about" component={About} />
          <Route path="/support" component={Support} />
          <Route path="/terms-service" component={TermsService} />
          <Route path="/privacy-policy" component={PrivacyPolicy} />
          <Route path="/forgot-password" component={ForgotPassword} />
          <Route path="/" component={Home} />
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
};

export default Routers;
